import React from 'react';

export const sceneThreeMeta = {
  id: 'bunun-coffee',
  title: '場景三｜布農部落的午後咖啡',
  excerpt: '在咖啡屋裡慢下來，聊第一性原理、根深曲線、人生、投資、家庭與焦慮。',
};

const SceneThreeBununCoffee: React.FC = () => (
  <article className="forest-article-detail">
    <h2>{sceneThreeMeta.title}</h2>
    <p>在休閒農場的咖啡屋裡，泡一杯咖啡。</p>
    <p>不急著趕路，也不急著證明自己。</p>
    <p>只是靜靜坐著，聽風穿過樹葉，聽蟲鳴鳥叫，看陽光慢慢落進山谷。</p>
    <p>有些答案，不是在競爭裡找到的，而是在安靜下來後，才開始慢慢浮現。</p>
    <p>我們聊第一性原理：什麼才是真正重要的？</p>
    <p>我們聊根深曲線：真正能長久成長的，往往不是最快的，而是根扎得最深的。</p>
    <p>也聊人生、投資、家庭與焦慮。</p>
    <p>原來很多人一生都在追趕，卻很少停下來問自己：</p>
    <ul>
      <li>我真正想成為什麼樣的人？</li>
      <li>我現在的努力，是否正在長出自己的森林？</li>
    </ul>
    <blockquote>森林，從不催促任何一棵樹。它只是靜靜等待，等待每個生命，長成自己本來的樣子。</blockquote>
  </article>
);

export default SceneThreeBununCoffee;
